var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{on:{"enter":_vm.afterEnter,"before-enter":_vm.beforeEnter}},[(_vm.show)?_c('div',{ref:"ball",staticClass:"move_dot"},[_c('img',{attrs:{"src":_vm.dropImage,"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }